import { SlicesImage } from './SlicesImage.js';

export class SlicesMediaTrack {

  constructor(props = {}) {
    this.url = props.url;
    this.subtitlesUrl = props.textUrl;
    this.posterImage = props.posterImage;
    this.audio = props.audio;
    this.video = props.video;
    this.loop = props.loop;
    this.muted = props.muted;
    this.controlsHidden = props.controlsHidden;
    this.controlsFullscreen = props.fullscreenControls;
  }

  get url() {
    return this['#url'] || '#';
  }

  set url(url = '') {
    this['#url'] = url;
  }

  get subtitlesUrl() {
    return this['#subtitlesUrl'];
  }

  set subtitlesUrl(subtitlesUrl = '') {
    this['#subtitlesUrl'] = subtitlesUrl;
  }

  get posterImage() {
    return this['#posterImage'] || new SlicesImage({});
  }

  set posterImage(posterImage = {}) {
    this['#posterImage'] = new SlicesImage(posterImage);
  }

  get sizes() {
    return this['#sizes'] || [];
  }

  set sizes(sizes = []) {
    this['#sizes'] = sizes;
  }

  get type() {
    return this['#type'] || 'audio';
  }

  get video() {
    return this['#type'] === 'video';
  }

  set video(video) {
    const isVideo = Boolean(video);
    this['#type'] = isVideo ? 'video' : 'audio';
  }

  get audio() {
    return this['#type'] === 'audio';
  }

  set audio(audio) {
    const isAudio = Boolean(audio);
    this['#type'] = isAudio ? 'audio' : 'video';
  }

  get loop() {
    return this['#loop'] || false;
  }

  set loop(loop) {
    this['#loop'] = Boolean(loop);
  }

  get muted() {
    return this['#muted'] || false;
  }

  set muted(muted) {
    this['#muted'] = Boolean(muted);
  }

  get controlsHidden() {
    return this['#controlsHidden'] || false;
  }

  set controlsHidden(controlsHidden) {
    this['#controlsHidden'] = Boolean(controlsHidden);
  }

  get controlsFullscreen() {
    return this['#controlsFullscreen'] || false;
  }

  set controlsFullscreen(controlsFullscreen) {
    this['#controlsFullscreen'] = Boolean(controlsFullscreen);
  }

  get hidden() {
    return !this['#url'];
  }

}